import React from "react";
import { CardSubHeading, CardText } from "../styles/CardStyles";
import { Button, Stack } from "@mui/material";
import { STAKING_POOL_CONFIG } from "../config";
import { ethers } from "ethers";
import { Contract } from "@ethersproject/contracts";
import poolAbi from "../config/abi/pool.json";
import { Pool } from "../config/abi/types";
import { OwnerCard } from "../views/StakingPool/PoolPage";

const UpdateMerkleRoot = ({
  account,
  pendingTxn,
  setPendingTxn,
  handleConnectWalletModalOpen,
  merkleRoot,
}: {
  account: string;
  pendingTxn: boolean;
  setPendingTxn: React.Dispatch<React.SetStateAction<boolean>>;
  handleConnectWalletModalOpen: () => void;
  merkleRoot: string;
}) => {
  const handleUpdateMerkleRoot = async () => {
    setPendingTxn(true);
    try {
      const provider = new ethers.providers.Web3Provider(
        // @ts-ignore
        (window as WindowChain).ethereum
      );
      const signer = provider.getSigner();
      const poolContract = (await new Contract(
        STAKING_POOL_CONFIG.id,
        poolAbi,
        signer
      )) as Pool;

      const txn = await poolContract.updateMerkleRoot(merkleRoot);

      txn.wait();
      setPendingTxn(false);
    } catch (err) {
      setPendingTxn(false);
      console.error("Error while rescuing funds: ", err);
    }
  };

  return (
    <OwnerCard>
      <Stack rowGap={3}>
        <CardText>Update Merkle Root</CardText>
        {account && (
          <Stack direction={"row"} justifyContent={"center"}>
            <CardSubHeading>
              Update the merkle root for accommodating the latest whitelisted
              addresses
            </CardSubHeading>
          </Stack>
        )}
        {account ? (
          <Button
            variant={"contained"}
            disabled={pendingTxn}
            onClick={handleUpdateMerkleRoot}
          >
            Update Merkle Root
          </Button>
        ) : (
          <Button variant={"outlined"} onClick={handleConnectWalletModalOpen}>
            Connect to Wallet
          </Button>
        )}
      </Stack>
    </OwnerCard>
  );
};

export default UpdateMerkleRoot;
